import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MapsService, snapshotToArray } from '@app/shared/services/map.service';
import { IPosition } from '@app/shared/interfaces/iposition';
import * as firebase from 'firebase/app';
import 'firebase/database';
import { properties } from '@env/properties.config';
declare const google: any;

@Component({
  selector: 'app-traking',
  templateUrl: './traking.component.html',
  styleUrls: ['./traking.component.scss']
})
export class TrakingComponent implements OnInit {
  ref = firebase.database().ref('geolocations/');
  deliveryMarker: any;
  clientMarker: any;
  map: any;
  directionsService: any;
  directionsDisplay: any;
  clientPosition: any;
  deliveryPosition: any;

  constructor(
    private mapsService: MapsService,
    private dialogRef: MatDialogRef<TrakingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    this.initMap();
  }

  initMap(): void {
    this.clientPosition = new google.maps.LatLng(
      this.data.latitude,
      this.data.longitude
    );
    this.deliveryPosition = new google.maps.LatLng(
      properties.maps.defaultLocation.latitude,
      properties.maps.defaultLocation.longitude
    );

    const mapOptions = {
      zoom: 12,
      center: this.clientPosition,
      scrollwheel: true,
      gestureHandling: 'cooperative',
      scaleControl: true
    };

    this.map = new google.maps.Map(
      document.getElementsByClassName('map')[0],
      mapOptions
    );
    this.addMarker(this.deliveryPosition, false);
    this.addMarker(this.clientPosition, true);
    this.map.panTo(this.clientPosition);
    this.directionsDisplay.setMap(this.map);

    const self = this;
    this.ref.orderByChild('orderId').equalTo(this.data.orderId).on('value', resp => {
      snapshotToArray(resp).forEach(data => {
        self.deliveryPosition = new google.maps.LatLng(data.latitude, data.longitude);
        if (self.deliveryMarker) {
          self.moveMarker();
          return;
        }
      });
    });
  }

  addMarker(location: any, isClient: boolean) {
    const icon = {
      url: 'assets/img/delivery-new.png',
      scaledSize: new google.maps.Size(32, 32),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0)
    };

    if (isClient) {
      this.clientMarker = new google.maps.Marker({
        position: location,
        map: this.map,
        icon: null
      });
      return;
    }

    this.deliveryMarker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon
    });
    this.calculateAndDisplayRoute();
  }

  moveMarker() {
    this.deliveryMarker.setPosition(this.deliveryPosition);
    this.map.panTo(this.deliveryPosition);
    this.calculateAndDisplayRoute();
    this.mapsService.setMarkerSizeByZoom(this.map, this.deliveryMarker);
  }


  close() {
    this.dialogRef.close();
  }

  calculateAndDisplayRoute(): void {
    const self = this;
    this.directionsService.route({
      origin: this.deliveryPosition,
      destination: this.clientPosition,
      travelMode: 'DRIVING'
    }, function (response, status) {
      if (status === 'OK') {
        self.directionsDisplay.setDirections(response);
      } else {
        console.log('Directions request failed due to ' + status);
      }
    });
  }
}
